import { render } from "./RoleAssignType.vue?vue&type=template&id=5c21f516&ts=true"
import script from "./RoleAssignType.vue?vue&type=script&lang=ts"
export * from "./RoleAssignType.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__